module.exports = __webpack_public_path__ + "img/46_5.062c988e.png";